import React from 'react';
import Exprience from './exprience/exprience.jsx'; 
import HeroSlider from './heroslider/heroslider.jsx'; 
import Homequotation from './quotation/homequotation.jsx';
import Package from '../package/package.jsx';
import Design from '../Home/homedesign/design.jsx';
import Work from '../Home/somework/work.jsx';
import Accordian from '../Home/accordian/accordian.jsx';
import Success from '../Home/success/success.jsx';
import Tesimonial from '../Home/powerfull/powerfull.jsx';
import './home.css'; 
import abimg1 from "../../images/c1 (1).png";
import abimg2 from "../../images/c1 (2).png";
import abimg3 from "../../images/c1 (3).png";
import abimg4 from "../../images/c1 (4).png";
import { Helmet } from "react-helmet-async";

function Home() {
 
  return (
    <>
    <Helmet>
        <title>Interior Designers in Kerala | Cedar Interiors</title>
        <meta name="description" content="Welcome to Cedar Interiors. Redefining interiors with bespoke designs for modular kitchens, living rooms, and more. Elevate your living experience today." />
      </Helmet>

  <HeroSlider/>
    <Exprience/>
    <Homequotation/>
    <Design/>
    <Package/>
    {/* <Chooseus/> */}
    <div className="aboutchoose">
        <div className="aboutchoosrow1">
          <div className="aboutchooserow1col col1">
            <h2 className="header2">Cedar Assurance</h2>
            <p>
            Cedar Assurance is our promise to make your interior journey seamless and stress-free. We go beyond delivering beautiful spaces by ensuring every detail reflects quality, precision, and care. With our unwavering commitment to innovation and client satisfaction, Cedar Interiors stands as your trusted partner in creating timeless spaces that inspire.
            </p>
          </div>
          <div className="aboutchooserow1col col2">
            <div className="yofexp">
              <p>45</p>
              <span>Days</span>
              <span>Delivery</span>
            </div>

            <div className="yofexp">
            <p>4Lakh</p>
              <span>SqFt</span>
              <span>Developed</span>
            </div>
            <div className="yofexp">
            <p>10</p>
              <span>Years</span>
              <span>Warranty</span>
            </div>
          </div>
        </div>
        {/*end*/}
        <div className="about-card">
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg1} alt="" />
              <h4>45 Days Delivery</h4>
              <p>
              Enjoy fast and reliable interior solutions for your new home with our guaranteed 45-day delivery. Your dream home, delivered on time.
              </p>
            </div>
          </div>
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg2} alt="" />
              <h4>Design Experts</h4>
              <p>
              Collaborate with our skilled designers to explore premium ideas and co-create interiors that match your unique style and vision.
              </p>
            </div>
          </div>
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg3} alt="" />
              <h4>Aftercare Service</h4>
              <p>
              Experience uninterrupted support with our dedicated customer care team, ensuring your interiors remain flawless even after project completion.
              </p>
            </div>
          </div>
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg4} alt="" />
              <h4>10-Year Warranty</h4>
              <p>
              Benefit from high-quality materials and craftsmanship backed by a 10-year warranty for a defect-free and lasting experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    <Work/>
    <Success/>
      <Tesimonial/>
      <Accordian/>  
    </>
   
  );
}

export default Home;

